module.exports = __webpack_public_path__ + "img/file-earmark-spreadsheet.3627aadb.svg";